import {Injectable} from '@angular/core';
import {GraphData} from '../types/nso-data-portal/census-data';
import {CHART_COLORS} from '../types/nso-data-portal/charts/chart-colors';


@Injectable()
export class ChartColorService {
  constructor() {
  }

  initialize(serverData: GraphData) {

    serverData.barGraphData.datasets.forEach((dataset, index) => {
      dataset.backgroundColor = CHART_COLORS.barBackgroundColor;
      dataset.borderColor = CHART_COLORS.borderColor[index];
      dataset.borderWidth = 2;
      dataset.hoverBackgroundColor = CHART_COLORS.hoverBackgroundColor[index];
    });

    serverData.donutBarData.datasets[0] = {
      ...serverData.donutBarData.datasets[0],
      backgroundColor: CHART_COLORS.backgroundColor,
      borderColor: CHART_COLORS.borderColor,
      hoverBackgroundColor: CHART_COLORS.hoverBackgroundColor
    };

    serverData.lineGraphData.datasets.forEach((dataset, index) => {
      dataset.fill = false;
      dataset.borderColor = CHART_COLORS.borderColor[index];
      dataset.borderWidth = 0.9;
      dataset.backgroundColor = CHART_COLORS.backgroundColor[index];
    });

    if (serverData.beneficiariesGraph) {
      serverData.beneficiariesGraph.datasets[0] = {
        ...serverData.beneficiariesGraph.datasets[0],
        backgroundColor: CHART_COLORS.backgroundColor,
        borderColor: CHART_COLORS.borderColor,
        hoverBackgroundColor: CHART_COLORS.hoverBackgroundColor
      };
    }
  }
}
